export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Checkbox/index.js
// module id = 662
// module chunks = 0